import dayjs from 'dayjs';
import {
  getClientCookie,
  getServerCookie,
  setServerCookie,
  setClientCookie,
  removeServerCookie,
  removeClientCookie,
} from './cookies';

export const ACCESS_TOKEN_KEY = 'token';
export const REFRESH_TOKEN_KEY = 'refresh_token';

export const getAccessToken = () => {
  try {
    const clientCookies = getClientCookie(ACCESS_TOKEN_KEY);
    const serverCookies = getServerCookie(ACCESS_TOKEN_KEY);
    if (
      (clientCookies && !serverCookies) ||
      (serverCookies && clientCookies && serverCookies !== clientCookies)
    )
      setServerCookie(ACCESS_TOKEN_KEY, clientCookies);
    if (serverCookies && !clientCookies)
      setClientCookie(ACCESS_TOKEN_KEY, serverCookies as string);
    return clientCookies as string;
  } catch (err) {
    return null;
  }
};

export const getRefreshToken = () => {
  try {
    const clientCookies = getClientCookie(REFRESH_TOKEN_KEY);
    const serverCookies = getServerCookie(REFRESH_TOKEN_KEY);
    if (
      (clientCookies && !serverCookies) ||
      (serverCookies && clientCookies && serverCookies !== clientCookies)
    )
      setServerCookie(REFRESH_TOKEN_KEY, clientCookies);
    if (serverCookies && !clientCookies)
      setClientCookie(REFRESH_TOKEN_KEY, serverCookies as string);
    return clientCookies as string;
  } catch (err) {
    return null;
  }
};

export const storeAccessToken = (accessToken: string): void => {
  try {
    setClientCookie(ACCESS_TOKEN_KEY, accessToken, {
      expires: dayjs().add(3, 'month').toDate(),
      sameSite: 'none',
      secure: true,
    });
    setServerCookie(ACCESS_TOKEN_KEY, accessToken, {
      expires: dayjs().add(3, 'month').toDate(),
      sameSite: 'none',
      secure: true,
    });
  } catch (error) {
    console.log(error);
  }
};

export const storeRefreshToken = (refreshToken: string) => {
  try {
    setClientCookie(REFRESH_TOKEN_KEY, refreshToken);
    setServerCookie(REFRESH_TOKEN_KEY, refreshToken);
  } catch (error) {
    console.log(error);
  }
};

export const removeAccessToken = () => {
  try {
    removeServerCookie(ACCESS_TOKEN_KEY);
    removeClientCookie(ACCESS_TOKEN_KEY);
  } catch (error) {
    console.log(error);
  }
};

export const removeRefreshToken = () => {
  try {
    removeServerCookie(REFRESH_TOKEN_KEY);
    removeClientCookie(REFRESH_TOKEN_KEY);
  } catch (error) {
    console.log(error);
  }
};
